import get from 'lodash/get';

// API
import { fetchUpcomingEvents, getCMSGlobalData } from "@/api";

// Utils
import { deserializeEventList } from "@/utils/deserializers/eventDeserializer";

// Constants
export const INITIALIZE_UPCOMING_EVENTS = "INITIALIZE_UPCOMING_EVENTS";
export const UPCOMING_EVENTS_LOADING = "UPCOMING_EVENTS_LOADING";

// Utils
export const initializeUpcomingEvents = (payload) => {
    return {
        type: INITIALIZE_UPCOMING_EVENTS,
        payload,
    };
};

export const upcomingEventsGetAndStore = (profileData) => {
    return (dispatch) => {
        dispatch({ type: UPCOMING_EVENTS_LOADING });
        Promise.all([fetchUpcomingEvents(profileData), getCMSGlobalData()])
            .then(([res, cmsGlobalDataRes]) => {
                const deserializedEventList = deserializeEventList(
                    res.data.data || res.data || [],
                    get(cmsGlobalDataRes, 'data.data') || []
                );
                dispatch(initializeUpcomingEvents(deserializedEventList));
            })
            .catch((err) => {
                console.log(err);
                dispatch(initializeUpcomingEvents([]));
            });
    };
};
